import React from 'react';

const Logo = ({ className = "", variant = "default" }) => {
  const colors = {
    default: {
      primary: "#0F766E", // Deep Teal
      accent: "#F59E0B" // Warm Amber
    },
    light: {
      primary: "#FFFFFF",
      accent: "#F59E0B"
    }
  };

  const currentColors = colors[variant] || colors.default;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="logo-icon"
      >
        {/* Geometric fabric roll representation */}
        <rect x="8" y="12" width="32" height="24" rx="2" fill={currentColors.primary} opacity="0.1"/>
        <rect x="10" y="14" width="28" height="4" rx="1" fill={currentColors.primary}/>
        <rect x="10" y="22" width="28" height="4" rx="1" fill={currentColors.accent}/>
        <rect x="10" y="30" width="28" height="4" rx="1" fill={currentColors.primary}/>
        
        {/* Letter A stylized */}
        <path
          d="M24 8L18 20H21L24 14L27 20H30L24 8Z"
          fill={currentColors.accent}
          strokeWidth="1.5"
          stroke={currentColors.primary}
        />
      </svg>
      <div className="flex flex-col">
        <span className="text-2xl font-bold tracking-tight leading-none" style={{ color: currentColors.primary }}>
          ARIHANT
        </span>
        <span className="text-sm font-semibold tracking-wider" style={{ color: currentColors.accent }}>
          SALES
        </span>
      </div>
    </div>
  );
};

export default Logo;
